import { FC, ReactNode } from 'react'
import { ScrollView, StyleProp, StyleSheet, ViewStyle } from 'react-native'

interface ScrollWrapperProps {
    children: ReactNode
    contentContainerStyle?: StyleProp<ViewStyle>
}

const ScrollWrapper: FC<ScrollWrapperProps> = ({ children, contentContainerStyle }) => {
    return (
        <ScrollView
            showsVerticalScrollIndicator={false}
            style={styles.container}
            contentContainerStyle={contentContainerStyle}
        >
            {children}
        </ScrollView>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 12,
    },
})

export default ScrollWrapper
